import Layout from "../components/Layout";

const Home = () => {
  return (
    <>
      <Layout />
    </>
  );
};

export default Home;
